import type { ReactNode } from "react";
import { cn } from "./cn";

/** Mirrors the Java `BadgeColor` set, minus the primary/non-primary split. */
export type BadgeVariant = "neutral" | "accent" | "success" | "warning" | "error" | "info";
export type BadgeSize = "sm" | "md";

const VARIANTS: Record<BadgeVariant, string> = {
  neutral: "bg-surface-sunk text-ink-muted",
  accent: "bg-accent-soft text-accent-strong",
  success: "bg-ok-soft text-ok",
  warning: "bg-warn-soft text-warn",
  error: "bg-risk-soft text-risk",
  info: "bg-info-soft text-info",
};

const SIZES: Record<BadgeSize, string> = {
  sm: "text-[11px] px-1.5 py-0.5",
  md: "text-xs px-2 py-0.5",
};

export interface BadgeProps {
  children: ReactNode;
  variant?: BadgeVariant;
  size?: BadgeSize;
  pill?: boolean;
  className?: string;
}

export function Badge({
  children,
  variant = "neutral",
  size = "md",
  pill = false,
  className,
}: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center font-medium whitespace-nowrap",
        pill ? "rounded-full" : "rounded",
        VARIANTS[variant],
        SIZES[size],
        className,
      )}
    >
      {children}
    </span>
  );
}
